const resetFields = {  
  password: {
    value: '',
    error: null,
    name: 'password',
    placeholder: 'Password',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'password',
    hasBlurred: false,
    inputType: 'password',
  },
  password_confirmation: {
    value: '',
    error: null,
    name: 'password_confirmation',
    placeholder: 'Confirm Password',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'password_confirm',
    hasBlurred: false,
    inputType: 'password',
  }
}

export default resetFields;



/** WEBPACK FOOTER **
 ** ./src/forms/member/reset.js
 **/